import { render, staticRenderFns } from "./CreateMethodDialog.vue?vue&type=template&id=8958645a"
import script from "./CreateMethodDialog.vue?vue&type=script&lang=js"
export * from "./CreateMethodDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports